/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';

function UsuarioList({ refresh, onEdit, onLink, onUsuarioDeleted }) {
  const { user } = useAuth();
  const [usuarios, setUsuarios] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchUsuarios = () => {
    api.get(`/usuarios?page=${page}&limit=${rowsPerPage}`)
      .then((response) => {
        setUsuarios(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar usuários:', error);
      });
  };

  useEffect(() => {
    fetchUsuarios();
  }, [refresh, page, rowsPerPage]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este usuário?')) return;
    try {
      await api.delete(`/usuarios/${id}`);
      console.log('Usuário deletado com sucesso!');
      onUsuarioDeleted();
      fetchUsuarios();
    } catch (error) {
      console.error('Erro ao deletar usuário:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="usuarios table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Email</TableCell>
              <TableCell>Tipo de Usuário</TableCell>
              <TableCell>Pessoa ID</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usuarios.map((usuario) => (
              <TableRow key={`${usuario.id}-${usuario.empresa_id}`} hover>
                <TableCell>{usuario.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{usuario.empresa_id}</TableCell>}
                <TableCell>{usuario.email}</TableCell>
                <TableCell>{usuario.tipo_usuario}</TableCell>
                <TableCell>{usuario.pessoa_id || 'N/A'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(usuario)}>
                    <EditIcon />
                  </IconButton>
                  <Tooltip title="Vincular outro condomínio">
                    <IconButton aria-label="vincular condomínio" onClick={() => onLink(usuario)}>
                      <LinkIcon />
                    </IconButton>
                  </Tooltip>
                  <IconButton aria-label="delete" onClick={() => handleDelete(usuario.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por página:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default UsuarioList;
